// @flow

import styled from "styled-components";

import buildColor from "../../_static/ColorPalette";
import { fontNormal } from "../../_static/Typography";

// hack for background safari https://stackoverflow.com/questions/21756467/ios7-safari-change-webkit-overflow-scrolling-background-color
export const TableHolder = styled.div`
  overflow-x: scroll;
  background: white;
  position: relative;
  margin-top: -1px;
`;

export const Table = styled.table`
  width: 0;
  min-width: 100%;
  table-layout: fixed;
  background-color: ${buildColor("white", "100")};
  font-size: 12px;
  text-align: center;
  top: 0;

  & > thead > tr {
    background-color: ${buildColor("blue", "100")};
    border-bottom: 1px solid ${buildColor("grey", "300")};
  }

  & > tbody > tr:nth-child(even) {
    background-color: ${buildColor("blue_accent", "000")};
  }
`;

export const Tr = styled.tr`
  border-bottom: 1px solid ${buildColor("blue", "100")};

  > th {
    border-bottom: 1px solid ${buildColor("grey", "300")};
  }
`;

export const Th = styled.th`
  width: 48px;
  height: 40px;
  background-color: ${buildColor("blue", "100")};
  position: sticky;
  left: 0;
  top: auto;
  z-index: 1;
  box-shadow: inset -1px 0 0 0 ${buildColor("grey", "300")};
`;

export const Td = styled.td`
  width: 62px;
  height: 40px;
`;

export const Anchor = styled.div`
  width: 100%;
  height: 40px;
  padding: 3px;
  position: relative;
  background-image: linear-gradient(
    to left bottom,
    transparent 49%,
    ${buildColor("grey", "300")} 50%,
    transparent 51%
  );

  & > span {
    font-size: 11px;
    font-weight: bold;
    display: block;
    height: 16px;
    line-height: 16px;
    position: absolute;
  }

  & > span:first-child {
    top: 0;
    right: 4px;
  }

  & > span:last-child {
    bottom: 4px;
    left: 4px;
  }
`;

export const Runner = styled.span`
  display: inline-flex;
  align-items: center;
  width: 16px;
  height: 16px;
`;

export const ColorSection = styled.section`
  background: ${buildColor("white", "100")};
  max-width: 100%;
`;

export const PoolAmountText = styled.span`
  color: ${buildColor("grey", "800")};
  font-size: 12px;
  font-family: ${fontNormal};
`;
